"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.create.title': 'Rozpocznij Nowy Onboarding',
};
